export default function attachBulkUploadDeailview(targetSelector){

  
}


// WEBPACK FOOTER //
// ./src/pages/bulkUpload/bulkUploadDetailView.js